import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import TofuProduct from 'models/TofuProduct'
import React, { useContext, useEffect, useState } from 'react'
import { Col, FormGroup, Row, Alert, Input } from 'reactstrap'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import { Controller, useFormContext, ErrorMessage } from 'react-hook-form'
import Switch from 'react-switch'
import { isNotNumericDecimal } from 'context/Utilities'

const TofuNutrition = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const { setSwitch, asterisk, onChange } = useFormUtils()

  const methods = useFormContext()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (
      current?.category === packagingInitialState.category &&
      current?.subCategory === packagingInitialState.subCategory
    ) {
      const { category, subCategory, Calcium, IsPlainRefrigerated } = current
      setPackaging({
        category,
        subCategory,
        Calcium,
        IsPlainRefrigerated: IsPlainRefrigerated ?? false,
      })
    } else if (!updating) {
      setCurrent(TofuProduct)
      setPackaging(packagingInitialState)
    }
    console.log(current)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Calcium (mg) per 100g tofu {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Calcium"
            placeholder={'Min 100mg calcium per 100g tofu'}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 6,
                message: '⚠ Calcium exceeds 6 characters.',
              },
              required: {
                value: true,
                message: '⚠ Calcium (mg) per 100g tofu is required.',
              },
              min: {
                value: 100,
                message:
                  '⚠ Calcium per 100g tofu is less than the 100mg minimum allowed.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Calcium"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>
              I certify that this product is plain and refrigerated. {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="IsPlainRefrigerated"
            id="IsPlainRefrigerated"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            checked={packaging.IsPlainRefrigerated}
            rules={{
              validate: IsPlainRefrigerated => IsPlainRefrigerated === true,
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="IsPlainRefrigerated"
              message={
                '⚠ You must certify that this product is plain and refrigerated.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default TofuNutrition
